/**
 * Ask for a reset link. The answer is the same whether or not the address has
 * an account (the API promises that), so the page just shows what it is told.
 */
import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import AuthCard, { AuthMessage, INPUT_CLASS, LABEL_CLASS, PRIMARY_BUTTON_CLASS } from '../components/AuthCard';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { message } = await api.forgotPassword(email);
      setSent(message);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Reset password">
      {sent ? (
        <AuthMessage tone="success">{sent}</AuthMessage>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6">
          {error && <AuthMessage tone="error">{error}</AuthMessage>}
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Enter the email you signed up with and we'll send a link to choose a new password.
          </p>
          <div>
            <label htmlFor="email" className={LABEL_CLASS}>
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={INPUT_CLASS}
            />
          </div>
          <button type="submit" disabled={loading} className={PRIMARY_BUTTON_CLASS}>
            {loading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
      )}
      <p className="text-center text-sm text-gray-600 dark:text-gray-300">
        <Link to="/login" className="text-blue-600 dark:text-blue-400 hover:text-blue-500">
          Back to sign in
        </Link>
      </p>
    </AuthCard>
  );
}
